import React from "react";
import { useFormikContext } from "formik";
import { usePendingPrefill, useSetDefaultValue } from "@hooks";
import Select from "@components/select";
import { STATE_OPTIONS } from "../../../../../constants/options";

export const State = () => {
  const name = "state";
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();

  useSetDefaultValue(name);
  usePendingPrefill(name);

  return (
    <Select
      isPlaceHolder
      placeholder="State"
      title="State"
      options={STATE_OPTIONS}
      onChange={handleChange}
      onBlur={handleBlur}
      value={values[name]}
      name={name}
      errorMessage={touched[name] ? errors[name] : ""}
    />
  );
};